(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // The scroll cue only exists on the phone hero, where the section fills the
  // screen and nothing below it is visible to hint at.
  document.addEventListener('click', (event) => {
    const cue = event.target.closest('.hero__scroll-cue');
    if (!cue) return;

    event.preventDefault();
    const section = cue.closest('.shopify-section');
    const next = section && section.nextElementSibling;

    if (next) {
      next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nisha-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nisha-product')) {
    customElements.define(
      'nisha-product',
      class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.nisha-pdp-section');
          this.colorPos = parseInt(this.dataset.colorPos, 10) || 0;
          this.sizePos = parseInt(this.dataset.sizePos, 10) || 0;
          this.gallery = this.querySelector('[data-gallery]');
          this.colorsets = Array.from(this.querySelectorAll('.nisha-pdp__colorset'));
          this.dots = this.section.querySelector('[data-dots]');
          this.swatches = Array.from(this.querySelectorAll('.nisha-pdp__sw'));
          this.sizesWrap = this.querySelector('[data-sizes]');
          this.sizeBtns = Array.from(this.querySelectorAll('.nisha-pdp__sz'));
          this.curColor = this.querySelector('[data-cur-color]');
          this.variantInput = this.querySelector('[data-variant-id]');
          this.form = this.querySelector('form');
          this.addBtns = Array.from(this.section.querySelectorAll('[data-add], [data-add-mobile]'));
          this.priceEls = Array.from(this.section.querySelectorAll('[data-price], [data-price-mobile]'));

          try {
            this.variants = JSON.parse(this.section.querySelector('[data-nisha-variants]').textContent);
          } catch (e) {
            this.variants = [];
          }

          this.live = this.querySelector('[data-status]');
          this.isSubmitting = false;

          // Adopt the selection Liquid rendered from `current_variant` (a ?variant= deep link, or
          // the first available one). Starting from swatch[0] instead made deep links open the
          // wrong colour, and updateVariant() then overwrote the hidden input to match it.
          const activeSw = this.swatches.find((s) => s.classList.contains('is-active')) || this.swatches[0];
          const activeSz = this.sizeBtns.find((b) => b.classList.contains('is-active'));
          this.selColor = activeSw ? activeSw.dataset.color : null;
          this.selSize = activeSz ? activeSz.dataset.size : null;

          // Fall back to the hidden input if no button carries the active class for some reason.
          if (!this.selColor || (this.sizePos > 0 && !this.selSize)) {
            const startId = parseInt(this.variantInput && this.variantInput.value, 10);
            const startVariant = this.variants.find((v) => v.id === startId);
            const startOpts = (startVariant && startVariant.options) || [];
            if (!this.selColor && this.colorPos > 0 && startOpts[this.colorPos - 1]) {
              this.selColor = startOpts[this.colorPos - 1];
            }
            if (!this.selSize && this.sizePos > 0 && startOpts[this.sizePos - 1] && startVariant.available !== false) {
              this.selSize = startOpts[this.sizePos - 1];
            }
          }

          this.swatches.forEach((sw) => sw.addEventListener('click', () => this.setColor(parseInt(sw.dataset.ci, 10))));
          this.sizeBtns.forEach((b) => b.addEventListener('click', () => this.setSize(b)));

          // The horizontal scroller is each .nisha-pdp__colorset (overflow-x + scroll-snap),
          // not [data-gallery]. scroll doesn't bubble, so listen on the colorsets themselves.
          let raf;
          this.colorsets.forEach((set) => {
            set.addEventListener(
              'scroll',
              () => {
                cancelAnimationFrame(raf);
                raf = requestAnimationFrame(() => this.syncDots());
              },
              { passive: true }
            );
          });

          this.addBtns.forEach((b) =>
            b.addEventListener('click', (e) => {
              e.preventDefault();
              this.addToCart(b);
            })
          );
          if (this.form) this.form.addEventListener('submit', (e) => e.preventDefault());

          this.setupViewer();

          this.buildDots();
          this.updateVariant();
          this.booted = true;
        }

        /* ===== Fullscreen photo viewer (mobile only for now) ===== */

        setupViewer() {
          this.viewer = this.querySelector('[data-viewer]');
          if (!this.viewer || typeof this.viewer.showModal !== 'function') return;

          this.viewerStage = this.querySelector('[data-viewer-stage]');
          this.viewerThumbs = this.querySelector('[data-viewer-thumbs]');
          this.viewerPrev = this.querySelector('[data-viewer-prev]');
          this.viewerNext = this.querySelector('[data-viewer-next]');
          this.viewerIndex = 0;

          const openFromEvent = (e) => {
            const shot = e.target.closest('.nisha-pdp__shot');
            if (!shot) return;
            const set = shot.parentElement;
            const shots = Array.from(set.querySelectorAll('.nisha-pdp__shot'));
            e.preventDefault();
            this.openViewer(shots.indexOf(shot));
          };

          this.colorsets.forEach((set) => {
            set.addEventListener('click', openFromEvent);
            set.addEventListener('keydown', (e) => {
              if (e.key !== 'Enter' && e.key !== ' ') return;
              if (!e.target.closest('.nisha-pdp__shot')) return;
              openFromEvent(e);
            });
          });

          this.querySelector('[data-viewer-close]').addEventListener('click', () => this.viewer.close());
          this.viewerPrev.addEventListener('click', () => this.stepViewer(-1));
          this.viewerNext.addEventListener('click', () => this.stepViewer(1));

          let vraf;
          this.viewerStage.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(vraf);
              vraf = requestAnimationFrame(() => this.syncViewer());
            },
            { passive: true }
          );

          // Esc and the backdrop close it natively; just undo the scroll lock.
          this.viewer.addEventListener('close', () => {
            document.documentElement.style.removeProperty('overflow');
          });

          // Arrow keys page through the photos once the viewer has focus.
          this.viewer.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
              e.preventDefault();
              this.stepViewer(-1);
            } else if (e.key === 'ArrowRight') {
              e.preventDefault();
              this.stepViewer(1);
            }
          });

          this.syncViewerAffordance();
        }

        // The shots are plain divs, so say out loud that they open something.
        syncViewerAffordance() {
          this.colorsets.forEach((set) => {
            set.querySelectorAll('.nisha-pdp__shot').forEach((shot) => {
              shot.setAttribute('role', 'button');
              shot.setAttribute('tabindex', '0');
              shot.setAttribute('aria-label', 'Apri la foto a schermo intero');
            });
          });
        }

        openViewer(index) {
          const set = this.activeColorset();
          if (!set) return;
          const imgs = Array.from(set.querySelectorAll('.nisha-pdp__shot img'));
          if (!imgs.length) return;

          this.viewerStage.innerHTML = '';
          this.viewerThumbs.innerHTML = '';

          imgs.forEach((img, i) => {
            const slide = document.createElement('div');
            slide.className = 'nisha-pdp__viewer-slide';
            slide.appendChild(this.cloneShot(img));
            this.viewerStage.appendChild(slide);

            const thumb = document.createElement('button');
            thumb.type = 'button';
            thumb.className = 'nisha-pdp__viewer-thumb';
            thumb.setAttribute('aria-label', 'Foto ' + (i + 1) + ' di ' + imgs.length);
            const thumbImg = this.cloneShot(img);
            thumbImg.removeAttribute('sizes');
            thumb.appendChild(thumbImg);
            thumb.addEventListener('click', () => this.goToViewer(i));
            this.viewerThumbs.appendChild(thumb);
          });

          document.documentElement.style.overflow = 'hidden';
          this.viewer.showModal();
          this.goToViewer(index, 'instant');
        }

        // Reuse the srcset the card already downloaded so reopening costs nothing.
        cloneShot(img) {
          const copy = img.cloneNode(true);
          copy.removeAttribute('loading');
          copy.removeAttribute('fetchpriority');
          copy.removeAttribute('class');
          return copy;
        }

        goToViewer(i, behavior) {
          const w = this.viewerStage.clientWidth || 1;
          this.viewerStage.scrollTo({ left: w * i, behavior: behavior || 'smooth' });
          this.viewerIndex = i;
          requestAnimationFrame(() => this.syncViewer());
        }

        stepViewer(step) {
          const n = this.viewerStage.children.length;
          const next = Math.max(0, Math.min(n - 1, this.viewerIndex + step));
          this.goToViewer(next);
        }

        syncViewer() {
          const n = this.viewerStage.children.length;
          if (!n) return;
          const w = this.viewerStage.clientWidth || 1;
          const i = Math.max(0, Math.min(n - 1, Math.round(this.viewerStage.scrollLeft / w)));
          this.viewerIndex = i;

          Array.from(this.viewerThumbs.children).forEach((t, ti) => {
            t.classList.toggle('is-active', ti === i);
            t.setAttribute('aria-current', ti === i ? 'true' : 'false');
          });

          this.viewerPrev.hidden = i === 0;
          this.viewerNext.hidden = i >= n - 1;

          // Keep the active thumbnail in view without letting scrollIntoView
          // pull the whole dialog around.
          const thumb = this.viewerThumbs.children[i];
          if (thumb) {
            const target = thumb.offsetLeft - (this.viewerThumbs.clientWidth - thumb.clientWidth) / 2;
            this.viewerThumbs.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
          }
        }

        activeColorset() {
          return this.colorsets.find((c) => !c.hasAttribute('hidden'));
        }

        setColor(i) {
          this.colorsets.forEach((c) => {
            const on = parseInt(c.dataset.ci, 10) === i;
            c.toggleAttribute('hidden', !on);
            c.classList.toggle('is-active', on);
          });
          this.swatches.forEach((s) => {
            const on = parseInt(s.dataset.ci, 10) === i;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          const sw = this.swatches[i];
          if (sw) {
            this.selColor = sw.dataset.color;
            if (this.curColor) this.curColor.textContent = sw.dataset.color;
          }
          const set = this.activeColorset();
          if (set) set.scrollLeft = 0;
          this.buildDots();
          this.updateVariant();
          // scroll up to the gallery when switching colour (desktop), like the prototype
          if (window.innerWidth > 749 && this.gallery) {
            const top = this.gallery.getBoundingClientRect().top + window.scrollY - 70;
            if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
          }
        }

        setSize(btn) {
          if (btn.disabled || btn.hasAttribute('data-soldout')) return;
          this.sizeBtns.forEach((b) => {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          this.selSize = btn.dataset.size;
          this.updateVariant();
        }

        buildDots() {
          if (!this.dots) return;
          const set = this.activeColorset();
          const n = set ? set.querySelectorAll('.nisha-pdp__shot').length : 0;
          this.dots.innerHTML = '';
          for (let a = 0; a < n; a++) {
            const d = document.createElement('button');
            d.type = 'button';
            d.className = 'nisha-pdp__dot' + (a === 0 ? ' on' : '');
            d.dataset.a = a;
            // Without a name these were 4-6 critical axe `button-name` violations per page.
            d.setAttribute('aria-label', 'Foto ' + (a + 1) + ' di ' + n);
            d.setAttribute('aria-current', a === 0 ? 'true' : 'false');
            d.addEventListener('click', () => {
              if (set) set.scrollTo({ left: set.clientWidth * a, behavior: 'smooth' });
            });
            this.dots.appendChild(d);
          }
        }

        syncDots() {
          if (!this.dots) return;
          const set = this.activeColorset();
          if (!set) return;
          const w = set.clientWidth || 1;
          const a = Math.round(set.scrollLeft / w);
          Array.from(this.dots.children).forEach((d, di) => {
            d.classList.toggle('on', di === a);
            d.setAttribute('aria-current', di === a ? 'true' : 'false');
          });
        }

        matchVariant() {
          return this.variants.find((v) => {
            const opts = v.options || [];
            const colorOk = this.colorPos === 0 || !this.selColor || opts[this.colorPos - 1] === this.selColor;
            const sizeOk = this.sizePos === 0 || !this.selSize || opts[this.sizePos - 1] === this.selSize;
            return colorOk && sizeOk;
          });
        }

        updateVariant() {
          // reflect sold-out sizes for the chosen colour
          if (this.sizePos > 0) {
            this.sizeBtns.forEach((b) => {
              const test = this.variants.find((v) => {
                const o = v.options || [];
                const colorOk = this.colorPos === 0 || o[this.colorPos - 1] === this.selColor;
                return colorOk && o[this.sizePos - 1] === b.dataset.size;
              });
              // A size this colour doesn't come in is as unbuyable as a sold-out one, and both
              // need a real `disabled` — `data-soldout` alone left the button clickable to
              // assistive tech and to a stale selection.
              const unavailable = !test || test.available === false;
              b.toggleAttribute('data-soldout', unavailable);
              b.disabled = unavailable;
              b.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
            });

            // Switching colour must not leave a size selected that this colour can't sell.
            if (this.selSize) {
              const stillSellable = this.sizeBtns.some((b) => b.dataset.size === this.selSize && !b.disabled);
              if (!stillSellable) {
                this.selSize = null;
                this.sizeBtns.forEach((b) => {
                  b.classList.remove('is-active');
                  b.setAttribute('aria-pressed', 'false');
                });
              }
            }
          }

          const variant = this.matchVariant();
          if (variant && this.variantInput) this.variantInput.value = variant.id;
          if (variant && variant.price != null) {
            const money = this.formatMoney(variant.price);
            this.priceEls.forEach((el) => (el.textContent = money));
          }

          // Keep the URL in step so the variant can be shared, reloaded and deep-linked back to.
          // Only after the first real selection — rewriting it on load would mutate the address
          // bar for visitors who never touched the picker.
          if (this.booted && variant && window.history && history.replaceState) {
            try {
              const url = new URL(window.location.href);
              url.searchParams.set('variant', variant.id);
              history.replaceState({}, '', url);
            } catch (e) {
              /* history is not worth breaking selection over */
            }
          }

          this.syncBuyState(variant);
        }

        // Lock the CTA on a resolved-but-unbuyable variant. With no size picked yet the existing
        // "Seleziona una taglia" nudge is the better prompt, so leave the button live for it.
        syncBuyState(variant) {
          const locked = !!variant && variant.available === false && (this.sizePos === 0 || !!this.selSize);
          this.addBtns.forEach((b) => {
            if (!b.dataset.labelDefault) b.dataset.labelDefault = b.textContent.trim();
            b.disabled = locked;
            b.setAttribute('aria-disabled', locked ? 'true' : 'false');
            b.textContent = locked ? 'Esaurito' : b.dataset.labelDefault;
          });
        }

        formatMoney(cents) {
          // Shopify variant price is in cents. `Theme.currency` did not exist, so this always
          // threw on `currency: undefined` and every market silently fell through to a hard EUR.
          const currency =
            (window.Theme && Theme.currency) || (this.section && this.section.dataset.currency) || 'EUR';
          try {
            return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: currency });
          } catch (e) {
            return '€' + (cents / 100).toFixed(2).replace('.', ',');
          }
        }

        addToCart(btn) {
          if (this.isSubmitting) return;
          const label = btn.dataset.labelDefault || btn.textContent;
          if (this.sizePos > 0 && !this.selSize) {
            if (this.sizesWrap) {
              this.sizesWrap.classList.remove('is-shake');
              void this.sizesWrap.offsetWidth;
              this.sizesWrap.classList.add('is-shake');
            }
            btn.textContent = 'Seleziona una taglia';
            setTimeout(() => (btn.textContent = label), 1300);
            if (window.innerWidth <= 749 && this.sizesWrap) {
              const t = this.sizesWrap.getBoundingClientRect().top + window.scrollY - 90;
              window.scrollTo({ top: t, behavior: 'smooth' });
            }
            return;
          }
          const variant = this.matchVariant();
          if (!variant) return;
          if (variant.available === false) {
            this.announce('Questa taglia non è al momento disponibile.');
            return;
          }

          // `Theme` is a top-level const, so `window.Theme` was undefined and this always fell
          // back to /cart/add — the form endpoint, which answers with a redirect, not JSON.
          const shopifyRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const addUrl =
            (window.Theme && Theme.routes && Theme.routes.cart_add_url) || shopifyRoot + 'cart/add.js';
          const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || shopifyRoot + 'cart';

          this.setSubmitting(true);
          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 }),
          })
            .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
            .then((res) => {
              // A 422 body parses as JSON perfectly well, so without this check every rejection
              // was rendered as "Aggiunto ✓" over an unchanged cart.
              if (!res.ok) {
                throw new Error(
                  (res.data && (res.data.description || res.data.message)) ||
                    'Non è stato possibile aggiungere il prodotto al carrello.'
                );
              }
              return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
            })
            .then((cart) => {
              this.setSubmitting(false);
              btn.classList.add('is-added');
              btn.textContent = 'Aggiunto ✓';
              this.announce('Prodotto aggiunto al carrello.');
              // notify Horizon's cart icon + drawer of the new total so the bubble count updates
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { resource: cart, data: { itemCount: cart.item_count, source: 'nisha-product' } },
                })
              );
              setTimeout(() => {
                btn.classList.remove('is-added');
                btn.textContent = label;
              }, 1600);
            })
            .catch((err) => {
              this.setSubmitting(false);
              btn.textContent = label;
              this.announce(
                (err && err.message) || 'Non è stato possibile aggiungere il prodotto al carrello.'
              );
            });
        }

        // One in-flight add at a time: a fast double tap used to fire two parallel POSTs.
        setSubmitting(on) {
          this.isSubmitting = on;
          this.addBtns.forEach((b) => {
            b.disabled = on;
            b.setAttribute('aria-busy', on ? 'true' : 'false');
          });
          if (!on) this.syncBuyState(this.matchVariant());
        }

        announce(message) {
          if (this.live) this.live.textContent = message;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
